import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { useInternationalization } from '../../../features/i18n'
import PageResult from '../../../features/search/components/page-result'
import { Featured, ListNav } from '../../program/components'

const DetailProgram = () => {
  const {
    data = {},
    featured_programs: defaultFeatureds
  } = useSelector(state => state.organization)
  const { id } = data
  const { translate } = useInternationalization()
  const history = useHistory()

  return (
    <PageResult
      customHeader={<></>}
      customNav={
        <>
          <Featured embed={true} defaultItems={defaultFeatureds}/>
          <ListNav
            fromOrganization={true}
            onChange={() => {}}
            handleStatistic={() => {history.push(`/program-statistic-organization/${id}`)}}
            handleMap={() => {history.push(`/program-map?organization=${id}`)}}
            activeTab={translate('VIEW', 'list')}
          />
        </>
      }
    />
  )
}

export { DetailProgram }
